import React from 'react'
import css from './TableHeader.module.css'

const TableHeader = props => (
  <div className={css.main}>
    <span className={css.value}>Name</span>
    <span className={css.value}>Last Updated At</span>
  </div>
)

export default TableHeader



// WEBPACK FOOTER //
// ./components/Customers/CustomersProfiles/TableHeader.js